// RTL direction is derived from the language code, not stored in the DB. Keep
// this set in sync with the backend mirror at
// api/src/modules/languages/lib/is-rtl-language.ts (which stamps
// PipeFullReleaseDto.isRtl at build time). The frontend uses this directly in
// the editor preview, where only the language code is known (no release flag).
const RTL_LANGUAGES = new Set(['ar', 'he', 'fa', 'ur', 'ckb', 'yi', 'dv', 'ps', 'sd', 'ug'])

export function isRtlLanguage(code: string | null | undefined): boolean {
  if (!code) return false
  return RTL_LANGUAGES.has(code.toLowerCase())
}
